"use client";

import Image from "next/image";
import Link from "next/link";
import { EquipmentCategory } from "@/types";
import { FaArrowRight } from "react-icons/fa6";

interface EquipmentCardProps {
  category: EquipmentCategory;
}

export default function EquipmentCard({ category }: EquipmentCardProps) {
  const title = category.shortTitle || category.title;
  const fullTitle = category.title;

  return (
    <Link
      href={`/capabilities/equipment/${category.slug}`}
      title={fullTitle}
      className="group relative flex flex-col justify-between bg-brand-card rounded-[10px] p-6 transition-all duration-300 "
    >
      {/* Top / Center Product Image */}
      <div className="relative w-full aspect-[4/3] flex items-center justify-center mb-6 overflow-hidden rounded-[8px] bg-white">
        <div className="relative w-full h-full transition-transform duration-500 ease-out">
          <Image
            src={category.image}
            alt={category.title}
            fill
            className="object-contain"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
      </div>

      {/* Bottom Bar: Title (Left) + Arrow Square (Right) */}
      <div className="flex items-center justify-between gap-3 min-w-0">
        <div className="relative group/tooltip min-w-0 flex-1">
          <h3
            title={fullTitle}
            className="font-poppins text-white/90 group-hover:text-white font-medium text-base sm:text-lg leading-snug truncate"
          >
            {title}
          </h3>

          {/* Styled Tooltip */}
          <div className="absolute bottom-full left-0 mb-2 hidden sm:group-hover/tooltip:block z-30 pointer-events-none transition-opacity duration-200">
            <div className="bg-brand-card text-white text-xs font-poppins px-3 py-1.5 rounded-[10px] border border-white/15  whitespace-normal max-w-[260px] leading-relaxed">
              {fullTitle}
            </div>
          </div>
        </div>

        <div className="shrink-0 w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-[10px] border border-white/20 group-hover:border-white bg-white/5 group-hover:bg-white text-white/70 group-hover:text-black transition-all duration-200">
          <FaArrowRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      </div>
    </Link>
  );
}
